module.exports = __webpack_public_path__ + "static/media/Angle's Class II Division I9.3c8fd4af.png";